var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "persistent": true,
      "title": _vm.$t('attachmentRequest.continueDialog.title'),
      "subtitle": _vm.$t('attachmentRequest.continueDialog.subtitle'),
      "isDialogActive": true,
      "leftText": _vm.$t('attachmentRequest.continueDialog.abort'),
      "rightText": _vm.$t('attachmentRequest.continueDialog.continue'),
      "hideClose": true
    },
    on: {
      "leftClick": _vm.abort,
      "rightClick": _vm.next
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }